<h1 mat-dialog-title>Solicitud partir puja</h1>
<div mat-dialog-content>
  <div *ngIf="pendingRequestsCount | pendingRequestsMessage as message" class="pending-requests-notification">
    <mat-icon class="notification-icon">info</mat-icon>
    <span>{{ message }}</span>
  </div>
  <p><strong>Lote:</strong> {{ lotCode }}</p>
  <p>El usuario "{{ username }}" está solicitando partir la puja</p>
  
  <form [formGroup]="form">
    <div fxLayout="row wrap" class="values-container">
      <div fxFlex="50" class="value-item">
        <span class="value-label">Valor actual:</span>
        <span class="value-amount" [appValueChangeHighlight]="currentBidValue">$ {{ currentBidValue | number:moneyNumberFormat }}</span>
      </div>
      
      <div fxFlex="50" class="value-item">
        <span class="value-label">Valor al partir:</span>
        <span class="value-amount" [appValueChangeHighlight]="newBidValue">$ {{ newBidValue | number:moneyNumberFormat }}</span>
      </div>
    </div>

    <div class="form-field-container">
      <mat-form-field>
        <mat-label>Valor a partir</mat-label>
        <input 
          matInput 
          type="number"
          formControlName="cutAmount"
          (blur)="onCutAmountBlur()"
          [appRestrictNumberDecimals]="!allowsDecimal"
          placeholder="Ingrese el valor a partir">
        <mat-hint>Valor que se restará de la puja actual</mat-hint>
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <app-action-loader #approveLoader>
    <button
      mat-raised-button
      color="primary"
      class="m-r-10"
      (click)="onApprove()"
      [disabled]="!form.valid || approveLoader.isRunning || rejectLoader.isRunning"
      tabindex="1">
      Aceptar
    </button>
  </app-action-loader>
  
  <app-action-loader #rejectLoader>
    <button
      mat-raised-button
      color="accent"
      (click)="onReject()"
      [disabled]="approveLoader.isRunning || rejectLoader.isRunning"
      tabindex="2">
      Denegar
    </button>
  </app-action-loader>
</div>

